export const environment = {
  production: false,
  apiUrl: 'https://procapi.energiasoi.com/api',
  liveMonitoringHubUrl: 'https://procapi.energiasoi.com/hubs/live-monitoring'
};
